export default {
    statusStepInitial: 'initial',
    statusStepEmailVerification: 'email_verification',
    statusStepPlan: 'plan',
    statusStepExistingEmail: 'existing_email',
    statusDisabled: 'disabled',
    statusPublish: 'publish',
    statusTrash: 'trash',
    statusMaintenance: 'maintenance',
    statusStepAccountVerification: 'account_verification',
    isSetup(status) {
        if (status === this.statusStepInitial || status === this.statusStepEmailVerification || status === this.statusStepPlan) {
            return true
        }
        return false
    },
    isEnabled(status) {
        if (status === this.statusPublish) {
            return true
        }
        return false
    }
}